module.exports = __webpack_public_path__ + "static/badges_1-e2a825168beed4e27aea51b23d38d479.svg";